import React from "react";
import styles from "./stepBar.module.scss";
import doneImg from "../../static/images/done.png";
import doneImgWhite from "../../static/images/doneWhite.png";

const StepBar = ({activeStep}) => {
	const steps = [
		{
			number: 1,
			title: "General Info",
		},
		{
			number: 2,
			title: "Address",
		},
		{
			number: 3,
			title: "Business",
		},
		{
			number: 4,
			title: "Service",
		},
		{
			number: 5,
			title: "Credit History",
		},
		{
			number: 6,
			title: "Owner",
		},
		{
			img: doneImg,
			imgWhite: doneImgWhite,
			title: "Documents",
		},
	];

	return (
		<div className={styles.stepBar}>
			<div className={styles.steps}>
				{steps.map((step, i) => {
					return (
						<div key={i} className={styles.step}>
							<div
								className={
									i <= activeStep
										? styles.activeWrappStepNumber
										: styles.wrappStepNumber
								}>
								<p
									className={
										i <= activeStep
											? styles.activeStepNumber
											: styles.stepNumber
									}>
									{step.img ? (
										<img src={step.imgWhite} alt="" />
									) : (
										step.number
									)}
								</p>
								<span
									className={i === 6 ? null : styles.lineStep}
								/>
								<span
									className={
										i === 0 ? null : styles.lineStepLeft
									}
								/>
							</div>
							<p
								className={
									i <= activeStep
										? styles.stepTitleActive
										: styles.stepTitle
								}>
								{step.title}
							</p>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default StepBar;
